"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseYarnLockV2Project = void 0;
const extract_yarnlock_v2_pkgs_1 = require("./extract-yarnlock-v2-pkgs");
const util_1 = require("../util");
const build_depgraph_simple_1 = require("./build-depgraph-simple");
const pkgJson_1 = require("../../aliasesPreprocessors/pkgJson");
const debugModule = require("debug");
const debug = debugModule('snyk-nodejs-lockfile-parser:component-metadata');
const parseYarnLockV2Project = async (pkgJsonContent, yarnLockContent, options, workspaceArgs) => {
    const { includeDevDeps, includeOptionalDeps, strictOutOfSync, pruneWithinTopLevelDeps, honorAliases, showNpmScope, includeComponentMetadata, } = options;
    if (includeComponentMetadata) {
        // Berry lockfiles store no tarball URL and only a `checksum` over yarn's cache artifact
        // (not the published tarball SRI), so component-metadata labels are deferred for yarn berry.
        debug('includeComponentMetadata is set but component-metadata labels are not yet produced ' +
            'for yarn berry (v2-4) lockfiles; skipping');
    }
    const pkgs = (0, extract_yarnlock_v2_pkgs_1.extractPkgsFromYarnLockV2)(yarnLockContent);
    const pkgJson = (0, util_1.parsePkgJson)(honorAliases ? (0, pkgJson_1.rewriteAliasesPkgJson)(pkgJsonContent) : pkgJsonContent);
    const depgraph = await (0, build_depgraph_simple_1.buildDepGraphYarnLockV2Simple)(pkgs, pkgJson, {
        includeDevDeps,
        strictOutOfSync,
        includeOptionalDeps,
        pruneWithinTopLevelDeps,
        showNpmScope,
    }, workspaceArgs);
    return depgraph;
};
exports.parseYarnLockV2Project = parseYarnLockV2Project;
//# sourceMappingURL=simple.js.map